export const modals = {
  copy: 'Kopiuj szablon konfiguracji',
  copySuccess: 'Skopiowano szablon konfiguracji',
  delete: 'Usuń szablon konfiguracji',
  deleteConfirm: 'Czy na pewno chcesz usunąć szablon konfiguracji?',
  deleteSuccess: 'Usunięto szablon konfiguracji',
} as const
